import { render, staticRenderFns } from "./DiceSlide.vue?vue&type=template&id=701282c0"
import script from "./DiceSlide.vue?vue&type=script&lang=js"
export * from "./DiceSlide.vue?vue&type=script&lang=js"
import style0 from "./DiceSlide.vue?vue&type=style&index=0&id=701282c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports